export enum DropoffSource {
  AZURE = "azure",
  JAMF = "jamf",
  KANDJI = "kandji",
  OTHER = "other",
}

export enum DropoffStatus {
  PROCESSING = "processing",
  DELAYED = "delayed",
  PROCESSED = "processed",
}

export enum DropoffCommunicationMethod {
  EMAIL = "Email",
  SLACK = "Slack (We'll add you to an external channel)"
}
